import React, { FC } from 'react';
import Head from 'next/head';

const MainHead: FC = () => {
  return (
    <Head>
      <meta charSet="utf-8" />
      <title>Интернет-магазин мебели Макрохим - гипермаркет мебели и товаров для дома в Москве</title>
      <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      <meta name="application-name" content="Макрохим"></meta>
      <meta name="apple-mobile-web-app-title" content="Макрохим"></meta>
    </Head>
  );
};

export { MainHead };
